import { Component, Input, OnInit } from '@angular/core';
import { ChartModule } from 'primeng/chart';
import Chart from 'chart.js/auto';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { combineLatest } from 'rxjs';
import { TranslocoService } from '@jsverse/transloco';
import { UtilsService } from '../../../../../core/services/utils.service';
@Component({
  selector: 'app-invoice-energy-doughnut-chart',
  standalone: true,
  imports: [ChartModule],
  templateUrl: './invoice-energy-doughnut-chart.component.html',
  styleUrl: './invoice-energy-doughnut-chart.component.css'
})
export class InvoiceEnergyDoughnutChartComponent implements OnInit {
  data: any;
  options: any;

  @Input() chartData: number[] = [4.95, 0.88, 28.46, 5.77, 59.94];
  @Input() kwhNumber: number = 0;

  labels: string[] = [
    'Energy',
    'TMS Charges',
    'Taxes',
    'Dispatching',
    'Unknown'
  ];

  constructor(private translocoService: TranslocoService, private utilsService: UtilsService) { }

  ngOnInit(): void {
    this.updateChart();
    const monthKeys = [
      'invoice.check_consumption',
      'shared.tms',
      'invoice.taxes',
      'invoice.dispatching',
      'shared.unknown'
    ];

    combineLatest(monthKeys.map((key) => this.translocoService.selectTranslate(key))).subscribe((translations) => {
      this.labels = translations;
      this.updateChart();
    });
  }

  updateChart(): void {
    Chart.register(ChartDataLabels);

    const centerTextInvoiceElectricityEnergyPlugin = {
      id: 'centerTextInvoiceElectricityEnergyPlugin',
      beforeDraw(chart: any) {
        const pluginOptions = chart.config.options.plugins?.centerTextInvoiceElectricityEnergyPlugin;
        if (!pluginOptions || pluginOptions.enabled === false) {
          return;
        }

        const ctx = chart.ctx;

        const { kwhNumber = '0' } = pluginOptions;
        const { top, bottom, left, right } = chart.chartArea;
        const centerX = (left + right) / 2;
        const centerY = (top + bottom) / 2;

        const text = `${kwhNumber}\n€/kWh`;

        ctx.save();
        ctx.font = 'bold 20px Arial';
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';

        text.split('\n').forEach((line, index) => {
          ctx.fillText(line, centerX, centerY + index * 20);
        });

        ctx.restore();
      },
    };
    Chart.register(centerTextInvoiceElectricityEnergyPlugin);

    this.data = {
      labels: this.labels,
      datasets: [
        {
          data: this.chartData,
          backgroundColor: ['#A9BE92', '#222A19', '#415130', '#566B40', '#C0C0C0'],
          hoverBackgroundColor: ['#A9BE92', '#222A19', '#415130', '#566B40', '#C0C0C0'],
          borderWidth: 0,
          borderRadius: 6,
          spacing: 2,
        },
      ],
    };

    this.options = {
      responsive: true,
      maintainAspectRatio: false,
      cutout: '65%',
      plugins: {
        legend: {
          position: 'right',
          labels: {
            usePointStyle: true,
            padding: 20,
            color: '#333',
            font: {
              size: 10
            },
            generateLabels: (chart: any) => {
              const data = chart.data;
              const meta = chart.getDatasetMeta(0);

              if (!data.labels?.length) {
                return [];
              }

              return data.labels.map((label: string, index: number) => {
                const wrappedLines = this.utilsService.getMultiLineLabels(label, 20);
                const style = meta.controller.getStyle(index);

                return {
                  text: wrappedLines,
                  fillStyle: style.backgroundColor,
                  strokeStyle: style.borderColor,
                  lineWidth: style.borderWidth,
                  hidden: !chart.getDataVisibility(index),
                  index,
                  pointStyle: 'circle',
                };
              });
            },
          },
        },
        datalabels: {
          display: false,
        },
        tooltip: {
          enabled: true,
          callbacks: {
            label: function (tooltipItem: any) {
              const dataset = tooltipItem.dataset;
              const currentValue = dataset.data[tooltipItem.dataIndex];

              return `${currentValue}`;
            }
          }
        },
        centerTextInvoiceElectricityEnergyPlugin: {
          enabled: true,
          kwhNumber: this.kwhNumber
        }
      },
      layout: {
        padding: 40,
      },
    };
  }
}
